<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      title="选择用户"
      width="800px">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="system/user">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="姓名：">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入员工姓名" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="employeeNo" align="center" width="100" label="员工编号"/>
      <el-table-column prop="employeeName" align="center" width="100" label="姓名"/>
      <el-table-column prop="gender" align="center" width="80" label="性别">
        <template slot-scope="scope">
          <span v-if="scope.row.gender === 0">男</span>
          <span v-if="scope.row.gender === 1">女</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="departmentName"
          show-overflow-tooltip
          align="left"
          min-width="120"
          label="部门"/>
      <el-table-column label="操作" align="center" width="80">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          userName: "",
          userType: "",
          employeeName: "",
          mobile: "",
          roleName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      onSelect(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
    },
  };
</script>